/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Cta_ButtonInputs */

const en_directory_ai_tools_cta_button = /** @type {(inputs: Directory_Ai_Tools_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with two selfies`)
};

const zh_directory_ai_tools_cta_button = /** @type {(inputs: Directory_Ai_Tools_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用两张自拍开始`)
};

/**
* | output |
* | --- |
* | "Start with two selfies" |
*
* @param {Directory_Ai_Tools_Cta_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_cta_button = /** @type {((inputs?: Directory_Ai_Tools_Cta_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Cta_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_cta_button(inputs)
	return zh_directory_ai_tools_cta_button(inputs)
});
export { directory_ai_tools_cta_button as "directory.ai_tools.cta_button" }